import { useState, useEffect, type FC } from 'react';
import { Trans } from 'react-i18next';

export interface TLoginSupportMessageProps {
  onNewCodeRequest: () => Promise<void>;
}

export const LoginSupportMessage: FC<TLoginSupportMessageProps> = ({
  onNewCodeRequest,
}) => {
  const [timeLeft, setTimeLeft] = useState(30);
  const [isWaiting, setIsWaiting] = useState(true);

  useEffect(() => {
    if (!isWaiting) return;

    if (timeLeft === 0) {
      queueMicrotask(() => {
        setIsWaiting(false);
      });
      return;
    }

    const timer = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft, isWaiting]);

  const handleNewCodeRequest = async (): Promise<void> => {
    await onNewCodeRequest();
    setTimeLeft(30);
    setIsWaiting(true);
  };

  if (isWaiting) {
    return (
      <p className="c-page-login__support">
        <Trans
          i18nKey="login.withCode.supportWaiting"
          values={{ seconds: timeLeft }}
        />
      </p>
    );
  }

  return (
    <p className="c-page-login__support">
      <Trans i18nKey="login.withCode.support">
        0<button onClick={handleNewCodeRequest}>1</button>
      </Trans>
    </p>
  );
};
